import Model, { hasMany } from '@ember-data/model';
import type PostalAddressModel from './postal-address.ts';

export default class PostalAddressable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('postal-address', {
    async: false,
    inverse: 'commentable',
    as: 'commentable',
  })
  declare postalAddresses: PostalAddressModel[];
}
